import * as React from 'react'
import { ListContainer, Section } from '../atoms'
import { ReducerProps } from '../reducer'
import { DragDrop } from './DragDrop'
import { sortPanelStyles as useStyles } from './styles'

import Typography from '@mui/material/Typography'
import { GridApi } from '@mui/x-data-grid-pro'

export const SortPanel: React.FC<
  ReducerProps & {
    apiRef: React.MutableRefObject<GridApi>
  }
> = (props) => {
  const { title, subTitle } = useStyles
  return (
    <Section blueBackground>
      <Typography sx={title}>Columns Selected to be Displayed</Typography>
      <Typography sx={subTitle}>(Drag to reorder)</Typography>
      <ListContainer>
        <DragDrop {...props} />
      </ListContainer>
    </Section>
  )
}
